import SplitText from 'gsap/SplitText';

class Footer {
  constructor() {
    this.footer = {
      el: document.getElementById('a-footer'),
      next: document.querySelectorAll('.footer-next .side'),
      contact: document.querySelectorAll('.footer-contact .side'),
    };
  }

  init() {
    const n = new SplitText(this.footer.next, { type: 'chars' });

    [...n.chars].forEach((e) => {
      this.wrap(e);
    });

    const c = new SplitText(this.footer.contact, { type: 'chars' });

    [...c.chars].forEach((e) => {
      this.wrap(e);
    });
  }

  wrap = (e) => {
    e.style.display = '';
    e.style.position = '';
    const d = document.createElement('div');
    d.classList.add('cube');
    e.parentNode.insertBefore(d, e);
    d.appendChild(e);
  }
}

export default Footer;
